import { useState, useEffect } from "react";
import { useTheme } from "../../../theme";
import { BRAND_COLORS } from "../../../theme/colors.js";
import { SOCIALS } from "../../../data/socials.js";

export default function FloatingContactCTA({ ready = false, onContactClick }) {
  const t = useTheme();
  const [visible, setVisible] = useState(false);
  const [hover, setHover] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Only start the slide-in timer once loading is done
  useEffect(() => {
    if (!ready) return;
    const timeout = setTimeout(() => setVisible(true), 3500);
    return () => clearTimeout(timeout);
  }, [ready]);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 200);
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  // Rotate when scrolled OR hovered — changes from vertical text to horizontal pill
  const isRotated = scrolled || hover;
  // Color escalation: default → scrolled (warm) → hover (hot)
  const ctaColor = hover
    ? BRAND_COLORS.cyan
    : scrolled
      ? BRAND_COLORS.orange
      : BRAND_COLORS.purple;

  return (
    <button
      type="button"
      onClick={onContactClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        position: "fixed",
        left: visible ? 0 : -200,
        top: "50%",
        zIndex: 90,
        padding: isRotated ? "12px 24px" : "14px 20px",
        borderRadius: isRotated ? "0 10px 10px 0" : "0 10px 10px 0",
        background: hover
          ? `${ctaColor}22`
          : scrolled
            ? t.navBg
            : t.overlayBg,
        border: `1px solid ${hover ? ctaColor : scrolled ? `${ctaColor}44` : t.borderStrong}`,
        borderLeft: "none",
        backdropFilter: "blur(20px)",
        color: ctaColor,
        fontFamily: "'DM Mono', monospace",
        fontSize: 10,
        fontWeight: 600,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        textDecoration: "none",
        cursor: "pointer",
        whiteSpace: "nowrap",
        writingMode: isRotated ? "horizontal-tb" : "vertical-lr",
        textOrientation: "mixed",
        transform: "translateY(-50%)",
        transition: "all 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        boxShadow: hover
          ? `0 0 30px ${ctaColor}33, inset 0 0 20px ${ctaColor}11`
          : scrolled
            ? `0 0 20px ${ctaColor}18`
            : "0 4px 20px rgba(0,0,0,0.3)",
        textShadow: hover ? `0 0 12px ${ctaColor}66` : "none",
      }}
    >
      Contact TLA
    </button>
  );
}
